import { ErrorIcon } from '@g2-apps/wu-dot-com/src/components/icons/ErrorIcon';
import { Iconify } from '@g2-shared/components';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { Box } from '@mui/system';
import { createContext, ReactNode, useState } from 'react';

interface ErrorModalProps {
  open: boolean;
  onClose: () => void;
  error?: string;
}

const ErrorModal = ({ open, onClose, error }: ErrorModalProps) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <IconButton onClick={onClose}>
        <Iconify icon="uil:times" sx={{ width: 25, height: 25 }} />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
        <ErrorIcon />

        <Box sx={{ mt: 3, color: '#212B36', fontSize: '24px', fontWeight: 700 }}>{error}</Box>
        {/* <Box */}
        {/*  sx={{ */}
        {/*    mt: 2, */}
        {/*    color: '#212B36', */}
        {/*    fontSize: '14px', */}
        {/*    textAlign: 'center', */}
        {/*  }} */}
        {/* > */}
        {/*  {t('failedTransactionText')} */}
        {/* </Box> */}
      </Box>
    </DialogContent>
  </Dialog>
);

export const ErrorModalContext = createContext({
  errors: [] as string[],
  setError: (err: string) => {},
});

export const ErrorModalProvider = ({ children }: { children: ReactNode }) => {
  const [errors, setErrors] = useState<string[]>([]);

  const closeError = (index: number) => setErrors(errors.filter((err, ind) => ind !== index));
  const setError = (error: string) => setErrors([...errors, error]);

  const value = { setError, errors };

  return (
    <ErrorModalContext.Provider value={value}>
      {errors.map((error, index) => (
        <ErrorModal open onClose={() => closeError(index)} error={error} />
      ))}

      {children}
    </ErrorModalContext.Provider>
  );
};
